import axios from "axios";
import { baseUrl } from "../common/siteSettings";
import heyapi from "../middleware/axiosInstance";

//current it will trigger immediately, later we can set time also from frontend
export const sendCronjobService = async (token,type) => {
      console.log(type)
    try {
        const response = await heyapi.post(
            `/admin/cronjob/${type}`,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        console.log(response);
        return response;
    } catch (err) {
        console.log(err);
    }
};